export default __webpack_public_path__ + "static/magicpatch-b1175fac4d4dacbd8c1ea351f6da984a.png";